import { Badge } from '@/components/ui/badge';
import { useResponsive } from '@/hooks/use-responsive';
import type { BlogDetailedPageDataResponse } from '@/services/cms/getBlogDetailedContent/schemas';
import formatDateString from '@/utils/dates';

interface BlogDetailedHeaderProps {
  blogDetailedHeaderData: BlogDetailedPageDataResponse;
}

export const BlogDetailedHeader = ({
  blogDetailedHeaderData,
}: BlogDetailedHeaderProps) => {
  const { categories, title, excerpt, date, feature_image } =
    blogDetailedHeaderData;
  const { isDesktop } = useResponsive();
  return (
    <div className="flex flex-col pt-8 gap-4 md:pt-12 md:gap-5 lg:gap-4">
      <div className="flex flex-col gap-2 md:gap-4">
        <Badge
          variant="black"
          size={isDesktop ? 'large' : 'medium'}
          className="max-w-max"
        >
          {categories[0].title}
        </Badge>

        <h1 className="font-lateral1000 text-3xl text-black md:text-4xl lg:text-5xl">
          {title}
        </h1>

        <p className="text-sm text-black font-light md:text-base lg:text-lg">
          {excerpt}
        </p>
      </div>

      <div className="flex flex-col gap-4 md:gap-5 lg:gap-12">
        <span className="text-xs font-light text-dark-grey-300 md:text-sm">
          {formatDateString(date)}
        </span>

        <div className="h-[158px] md:h-[288px] lg:h-[462px] rounded-3xl">
          <img
            className="w-full h-full object-cover rounded-3xl"
            src={feature_image?.url}
            alt={feature_image?.alt ?? ''}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};
